import Vue from 'vue';
import VueI18n from 'vue-i18n';
import locale from 'element-ui/lib/locale'; // 引入 Element UI 的国际化支持
import en from './en';
import zh from './zh';
import enLocale from 'element-ui/lib/locale/lang/en'; // Element UI 的英文语言包
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'; // Element UI 的中文语言包

Vue.use(VueI18n);

const messages = {
  en: {
    ...en,
    ...enLocale
  },
  zh: {
    ...zh,
    ...zhLocale
  }
};

const i18n = new VueI18n({
  locale: localStorage.getItem('lang') || 'zh', // 默认语言
  messages
});

locale.i18n((key, value) => i18n.t(key, value)); // 配置 Element UI 的国际化方法
export default i18n;



// WEBPACK FOOTER //
// ./src/admin/i18n/index.js